export const neutral = {
  // neutral
  100: '#FFFFFF',
  95: '#fafafa',
  90: '#E5E5E5',
  80: '#CCCCCC',
  70: '#B2B2B2',
  65: '#A6A6A6',
  60: '#999999',
  55: '#8C8C8C',
  50: '#808080',
  45: '#737373',
  40: '#666666',
  35: '#595959',
  30: '#4D4D4D',
  25: '#404040',
  20: '#333333',
  15: '#262626',
  10: '#1A1A1A',
  5: '#0D0D0D',
  0: '#000000',
};
